let load = require('./helpers/browser/esm-js-loader');
module.exports = Promise.all([load("ffQaD"), load("kvRbA"), load("dSZ60")]).then(() => parcelRequire('bsJdy'));